module.exports = "../../app/cells/components/contextual_course_banner_cell.rb";